import { useState } from 'react';
import { LearnerAndInviteeResponse, useGetLearnerByEmail } from 'api';

export type UseGetMergeLearnerTargetResult = {
  resolve: (email: string) => void;
  target: LearnerAndInviteeResponse | undefined;
  isResolving: boolean;
  error: Error | null;
  reset: () => void;
};

const useGetMergeLearnerTarget = (
  organisationId: string,
): UseGetMergeLearnerTargetResult => {
  const [email, setEmail] = useState('');

  const {
    data: target,
    isFetching: isResolving,
    error,
  } = useGetLearnerByEmail(organisationId, email);

  return {
    resolve: setEmail,
    target,
    isResolving,
    error,
    reset: () => setEmail(''),
  };
};

export default useGetMergeLearnerTarget;
